import * as React from 'react';
import { FieldDictionary } from '@shopify/react-form';
import { BreakAttestation } from '@sdk/automatedBreaks/types/Attestation';
import { AllBreakTypes } from '@sdk/settings/types';

import {
  TimeClockEntry,
  ValidationResults,
} from '@web/timesheets/CreateTimesheetModal/createTimesheetModal.types';
import TimeClockSection from '@web/timesheets/CreateTimesheetModal/components/TimeClockSections/TimeClockSection';
import { StartDateWithLocalTime } from '@web/timesheets/EditTimesheetModal/editTimesheetModal.types';
import { useTimeClockSections } from '@web/timesheets/CreateTimesheetModal/components/TimeClockSections/timeClockSections.hooks';

type Props = {
  timeClockFields: FieldDictionary<TimeClockEntry>[];
  submitErrors: ValidationResults;
  setSubmitErrors: React.Dispatch<React.SetStateAction<ValidationResults>>;
  scheduledShiftStart?: StartDateWithLocalTime;
  breakAttestations?: BreakAttestation[];
  askForExcessiveBreaksConfirmation?: () => Promise<boolean>;
  chooseAttestationToReplace?: (arg: {
    breakType: AllBreakTypes;
    breakNumbers: number[];
  }) => Promise<number | boolean>;
};
const TimeClockSections = ({
  timeClockFields,
  submitErrors,
  setSubmitErrors,
  scheduledShiftStart,
  breakAttestations = [],
  askForExcessiveBreaksConfirmation,
  chooseAttestationToReplace,
}: Props) => {
  const { isLastSection, hasMultipleSections, remove, visibleTimeClockFields } =
    useTimeClockSections(timeClockFields);

  return (
    <>
      {visibleTimeClockFields.map(
        (timeClockFieldSet: FieldDictionary<TimeClockEntry>, index: number) => (
          <TimeClockSection
            key={timeClockFieldSet.key.value}
            timeClockFieldSet={timeClockFieldSet}
            breakAttestations={breakAttestations}
            askForExcessiveBreaksConfirmation={askForExcessiveBreaksConfirmation}
            chooseAttestationToReplace={chooseAttestationToReplace}
            submitErrors={submitErrors}
            setSubmitErrors={setSubmitErrors}
            isLastSection={isLastSection(index)}
            isRemovable={hasMultipleSections}
            remove={() => remove(index)}
            scheduledShiftStart={scheduledShiftStart}
          />
        )
      )}
    </>
  );
};

export default TimeClockSections;
